import React from "react";
import SelectService from "../../components/SelectService";

const Server5 = () => {
  return (
    <>
      <SelectService server={'5'} />
    </>
  );
};

export default Server5;
